import { Injectable } from '@angular/core';
import jwt_decode from 'jwt-decode';
import { Observable, Subject } from 'rxjs';

const TOKEN_KEY = 'auth-token';
const REFRESHTOKEN_KEY = 'auth-refreshtoken';
const USER_KEY = 'auth-user';

@Injectable({
  providedIn: 'root',
})
export class TokenService {
  public jwtToken: string;
  public decodedToken: { [key: string]: string };

  public companyLogo = new Subject();

  public saveToken(token: string): void {
    if (token) {
      this.jwtToken = token;
    }

    window.localStorage.removeItem(TOKEN_KEY);
    window.localStorage.setItem(TOKEN_KEY, token);
    const user = this.getUser();
    if (user.id) {
      this.saveUser({ ...user, accessToken: token });
    }
  }

  public getUser() {
    const user = window.localStorage.getItem(USER_KEY);
    if (user) {
      return JSON.parse(user);
    }
    return {};
  }

  public saveUser(user: any): void {
    window.localStorage.removeItem(USER_KEY);
    window.localStorage.setItem(USER_KEY, JSON.stringify(user));
  }

  public updateUserCompany(company: any) {
    let authenticatedUser = this.getUser();
    authenticatedUser.company = company;
    this.saveUser(authenticatedUser);

    this.companyLogo.next(company.logo);
  }

  public getLogo(): Observable<any> {
    return this.companyLogo.asObservable();
  }

  public getToken(): string | null {
    this.jwtToken = window.localStorage.getItem(TOKEN_KEY);
    return this.jwtToken;
  }

  public saveRefreshToken(token: string): void {
    window.localStorage.removeItem(REFRESHTOKEN_KEY);
    window.localStorage.setItem(REFRESHTOKEN_KEY, token);
  }

  public getRefreshToken(): string | null {
    return window.localStorage.getItem(REFRESHTOKEN_KEY);
  }

  public signOut(): void {
    window.localStorage.removeItem(TOKEN_KEY);
    window.localStorage.removeItem(USER_KEY);
    window.localStorage.removeItem(REFRESHTOKEN_KEY);
  }

  private decodeToken() {
    this.getToken();
    if (this.jwtToken) {
      this.decodedToken = jwt_decode(this.jwtToken);
    }
  }

  /** To check if there is a token, we can check this value */
  public getExp() {
    this.decodeToken();
    return this.decodedToken ? this.decodedToken['exp'] : null;
  }

  private getExpiryTime() {
    this.decodeToken();
    return this.decodedToken ? this.decodedToken['exp'] : null;
  }

  public isTokenExpired(): boolean {
    const expiryTime: number = parseInt(this.getExpiryTime());

    if (expiryTime) {
      return 1000 * expiryTime - new Date().getTime() < 5000;
    } else {
      return false;
    }
  }
}
